import type React from "react";
import { Link } from "react-router-dom";
import logo from "@/assets/logo-crealavoro.png";

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[var(--color-surface)] border-t border-[var(--color-border)] mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Column 1: About */}
          <div className="space-y-4">
            <Link to="/" className="inline-block" aria-label="Crea Lavoro - Home">
              <img src={logo} alt="Crea Lavoro" className="h-12 w-auto" />
            </Link>
            <p className="text-sm text-text-secondary leading-relaxed">
              La piattaforma che connette studenti e laureati con opportunità di lavoro, stage e
              tirocini presso enti e associazioni.
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-text-primary uppercase tracking-wider mb-4">
              Esplora
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/studenti"
                  className="text-sm text-text-secondary hover:text-primary transition-colors duration-[var(--transition-fast)]"
                >
                  Per Studenti
                </Link>
              </li>
              <li>
                <Link
                  to="/laureati"
                  className="text-sm text-text-secondary hover:text-primary transition-colors duration-[var(--transition-fast)]"
                >
                  Per Laureati
                </Link>
              </li>
              <li>
                <Link
                  to="/enti"
                  className="text-sm text-text-secondary hover:text-primary transition-colors duration-[var(--transition-fast)]"
                >
                  Enti e Associazioni
                </Link>
              </li>
              <li>
                <Link
                  to="/opportunita"
                  className="text-sm text-text-secondary hover:text-primary transition-colors duration-[var(--transition-fast)]"
                >
                  Opportunità
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Resources */}
          <div>
            <h3 className="text-sm font-semibold text-text-primary uppercase tracking-wider mb-4">
              Risorse
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/risorse"
                  className="text-sm text-text-secondary hover:text-primary transition-colors duration-[var(--transition-fast)]"
                >
                  Risorse
                </Link>
              </li>
              <li>
                <Link
                  to="/contatti"
                  className="text-sm text-text-secondary hover:text-primary transition-colors duration-[var(--transition-fast)]"
                >
                  Contatti
                </Link>
              </li>
              <li>
                <Link
                  to="/chi-siamo"
                  className="text-sm text-text-secondary hover:text-primary transition-colors duration-[var(--transition-fast)]"
                >
                  Chi Siamo
                </Link>
              </li>
              <li>
                <Link
                  to="/come-funziona"
                  className="text-sm text-text-secondary hover:text-primary transition-colors duration-[var(--transition-fast)]"
                >
                  Come Funziona
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Legal */}
          <div>
            <h3 className="text-sm font-semibold text-text-primary uppercase tracking-wider mb-4">
              Legale
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/privacy"
                  className="text-sm text-text-secondary hover:text-primary transition-colors duration-[var(--transition-fast)]"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/termini"
                  className="text-sm text-text-secondary hover:text-primary transition-colors duration-[var(--transition-fast)]"
                >
                  Termini di Servizio
                </Link>
              </li>
              <li>
                <Link
                  to="/cookie"
                  className="text-sm text-text-secondary hover:text-primary transition-colors duration-[var(--transition-fast)]"
                >
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[var(--color-border)]">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-text-tertiary">
              {currentYear} Crea Lavoro. Tutti i diritti riservati.
            </p>
            <div className="flex items-center space-x-6">
              <span className="text-xs text-text-tertiary">
                Sviluppato con passione per studenti e laureati italiani
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
